import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, homeFor } from '../context/AuthContext';

// Domaines réservés aux rôles « métier » (rh, comptable, achats).
// `allow` : rôles métier admis en plus sur une page partagée (ex. le comptable consulte les BL).
const DOMAIN_ROLES = { rh: ['rh'], compta: ['comptable'], achats: ['achats'], briques: ['briques', 'resp_briques'], garde: ['vigile', 'sous_admin'] };

const ProtectedRoute = ({ children, adminOnly = false, dashboardAccess = false, domain = null, allow = [], validator = false, everyone = false, paie = false, numerotation = false, depenses = false }) => {
  const { user, roles, isMetier, isAdmin, loading, canViewDashboard, canManageUsers, mustChangePassword, canValiderFactures, canPaie, canNumeroter, canDepenses } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!user) {
    // Après connexion, retour à la page demandée (ex. lien « Ouvrir et valider » reçu par email)
    const suite = `${location.pathname}${location.search}`;
    return <Navigate to={suite && suite !== '/' ? `/login?suite=${encodeURIComponent(suite)}` : '/login'} replace />;
  }

  // Mot de passe provisoire : changement obligatoire avant toute autre page
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  // `validator` : page de consultation ouverte aussi aux valideurs des factures (PDG, DGA…)
  const okDomain = everyone || (domain && (DOMAIN_ROLES[domain] || []).some((r) => roles.includes(r))) || allow.some((r) => roles.includes(r)) || (validator && canValiderFactures) || (numerotation && canNumeroter) || (depenses && canDepenses);
  // Rôles métier seuls : uniquement les pages de leurs domaines
  if (isMetier && location.pathname !== '/change-password' && !okDomain) {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  // Page d'un domaine métier : administrateur ou rôle du domaine
  if (domain && !isAdmin && !okDomain) {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  // Paie et salaires : comptables autorisés seulement
  if (paie && !canPaie) {
    return <Navigate to="/compta" replace />;
  }

  if (adminOnly && !canManageUsers) {
    return <Navigate to={homeFor(user.role)} replace />;
  }

  if (dashboardAccess && !canViewDashboard) {
    return <Navigate to="/daily-report" replace />;
  }

  return children;
};

export default ProtectedRoute;
